// Parsing e classificação de origem de install. Sem imports de React Native, para ser
// testável direto (ver .test.ts). Parser manual porque o RN NÃO implementa
// `URLSearchParams.get` nem `URL.search` — as duas lançam "is not implemented".

export type AttributionSource =
  | 'organic'
  | 'campaign'
  | 'facebook'
  | 'google'
  | 'instagram'
  | 'tiktok'
  | 'store'
  | 'picpay'
  | 'x'
  | 'spotify';

export type UtmParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;

  gclid?: string;
  fbclid?: string;
  ad_id?: string;
};

function parseQueryString(str: string): Record<string, string> {
  const out: Record<string, string> = {};

  for (const pair of str.split('&')) {
    if (!pair) {continue;}
    const eq = pair.indexOf('=');
    if (eq < 1) {continue;}

    try {
      // Install referrer da Play chega com `+` no lugar de espaço, além do percent-encoding.
      out[decodeURIComponent(pair.slice(0, eq).replace(/\+/g, ' '))] = decodeURIComponent(
        pair.slice(eq + 1).replace(/\+/g, ' '),
      );
    } catch {
      // par malformado (percent-encoding inválido): ignora só ele, não a query inteira
    }
  }

  return out;
}

// Extrai a query de uma URL sem `new URL()`, que também é incompleto no RN.
export function queryStringOf(url: string): string {
  const start = url.indexOf('?');
  if (start < 0) {return '';}
  const rest = url.slice(start + 1);
  const hash = rest.indexOf('#');
  return hash < 0 ? rest : rest.slice(0, hash);
}

export function parseUTMsFromString(str: string): UtmParams {
  const params = parseQueryString(str);
  return {
    utm_source: params.utm_source || undefined,
    utm_medium: params.utm_medium || undefined,
    utm_campaign: params.utm_campaign || undefined,
    utm_content: params.utm_content || undefined,
    utm_term: params.utm_term || undefined,
    gclid: params.gclid || undefined,
    fbclid: params.fbclid || undefined,
    ad_id: params.ad_id || undefined,
  };
}

export function determineSource(url: string, utms: UtmParams): AttributionSource {
  const lowerUrl = url.toLowerCase();
  const src = (utms.utm_source || '').toLowerCase();

  if (src === 'picpay') {return 'picpay';}
  if (src === 'instagram' || lowerUrl.includes('instagram.com')) {return 'instagram';}
  if (src === 'x' || src === 'twitter') {return 'x';}
  if (src === 'spotify') {return 'spotify';}
  if (
    src === 'facebook' ||
    utms.fbclid ||
    lowerUrl.includes('facebook.com') ||
    lowerUrl.includes('fb.com')
  )
    {return 'facebook';}
  if (src === 'tiktok' || lowerUrl.includes('tiktok.com')) {return 'tiktok';}
  // Sinais explícitos do Google (gclid / utm_source=google) vencem primeiro. A checagem
  // de loja vem ANTES do substring 'google.com' — senão play.google.com casa 'google.com'
  // e install orgânico de loja é classificado como google, inflando o canal.
  if (src === 'google' || utms.gclid) {return 'google';}
  if (lowerUrl.includes('appstore') || lowerUrl.includes('play.google.com')) {return 'store';}
  if (lowerUrl.includes('google.com')) {return 'google';}
  if (utms.utm_source || utms.utm_campaign) {return 'campaign';}

  return 'organic';
}
